const moduleName = 'currentYear'

module.exports = () => {
  const date = new Date()
  const year = date.getFullYear()
  const el = document.querySelector('.js-current-year')

  if (el) {
    el.innerHTML = year
  }
}